<div *ngIf="!!portfolio && portfolio.trial" class="alert alert-primary" role="alert">
	<p>{{ 'upgrade.bar.title' | translate:{'days': portfolio.getRemainingTrialDays()} }} <a [routerLink]="['/upgrade']">{{ 'upgrade.bar.button' | translate }}</a>.</p>
</div>
